<template>
  <div class="page-element" @click="click" :class="calcClass" :data-playing="isPlaying" :style="compStyle">
    <button :title="element.attachment.name">
      <t-icon :name="iconName" />
    </button>
  </div>
</template>

<script>
import { assetApi } from 'api'
import { mapActions, mapGetters } from 'vuex'
import EventBus from '@/utils/eventBus'
export default {
  data () {
    return {
      sources: []
    }
  },
  mounted () {
    this.setStreamUrl()
  },
  methods: {
    ...mapActions('audio', ['setSelected']),
    setStreamUrl () {
      this.sources = [ assetApi.getStreamUrl(this.element.attachment.assetUrlPath) ]
    },
    click () {
      if (this.isPlaying) {
        EventBus.$emit('stop')
      } else {
        if (this.selectedAudio === null || this.selectedAudio.assetId !== this.element.attachment.assetId) {
          this.setSelected(this.element.attachment)
        }
        this.$nextTick(() => EventBus.$emit('play'))
      }
    }
  },
  computed: {
    ...mapGetters('audio', { selectedAudio: 'selected', playerPlaying: 'playing' }),
    compStyle () {
      return {
        top: `${this.element.y}px`,
        left: `${this.element.x}px`
      }
    },
    calcClass () {
      if (this.element.size) {
        return this.element.size.toLowerCase()
      }
    },
    isPlaying () {
      return this.selectedAudio !== null && this.selectedAudio.assetId === this.element.attachment.assetId && this.playerPlaying
    },
    iconName () {
      var iconName = 'icon-sound'

      if (this.calcClass === 'large') {
        iconName = 'icon-play'
      }

      return iconName
    }
  },
  props: [
    'element'
  ]
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/page/PageElement.vue